// extracted by mini-css-extract-plugin
export var layoutContainer = "_65-0";
export var layoutContainerNoRounding = "_65-6";
export var layoutContainerOpen = "_65-5";
export var layoutContainerResizing = "_65-1";
export var mainContent = "_65-2";
export var resizeDivider = "_65-3";
export var slidePanel = "_65-4";